import { EMPTY_OBJECT } from '../consts/empty';
import { getIsScreenActive, type JsonMap } from './analytics';
import type { TrackEventProperties } from './useAnalytics';

// The analytics `beforeEvent` hook: reshapes every event into the UnifyApps "activity" schema
// the tracking API stores. Shared by carbon's matrix provider AND the app-builder-sdk's provider
// so a code app's rows are indistinguishable from a no-code app's in the shared insights
// dashboard. `componentId` is the page grain (the route path); the owning app is identified out
// of band by the `x-ua-app` header the fetch carries, not by anything in this body.
export const getEventPayload =
  (getTrackingDataFn: () => { componentId: string }) => (eventType: string, data: JsonMap) => {
    const isScreenActive = getIsScreenActive();

    switch (eventType) {
      case 'track': {
        const activityType = data.event;
        const { componentId } = getTrackingDataFn();
        const {
          activityTime,
          activityCategory,
          assetType,
          assetId,
          metrics,
          screen,
          attributes,
          ...rest
        } = data.properties as TrackEventProperties;
        const _assetType = assetType ?? 'PAGE';

        return {
          ...rest,
          activityType,
          activityCategory: activityCategory ?? 'PERFORMANCE',
          activityTime: activityTime ?? Date.now(),
          assetType: _assetType,
          assetId: assetId ?? (_assetType === 'PAGE' ? componentId : undefined),
          metrics,
          screenContext: { pageId: componentId, isScreenActive, ...(screen ?? EMPTY_OBJECT) },
          attributes,
        };
      }
      case 'heartbeat': {
        const { componentId } = getTrackingDataFn();

        return {
          activityType: 'HEARTBEAT',
          activityCategory: 'ENGAGEMENT',
          activityTime: Date.now(),
          assetType: 'PAGE',
          assetId: componentId,
          screenContext: { pageId: componentId, isScreenActive },
        };
      }
      default:
        return data;
    }
  };
